import { Risk } from '@/api/use-service'

export const getElementById = (id: string) => document.getElementById(id)!

export const INVITATION_CODE_KEY = 'invitation-code'

const keyBefore = 'secura-platform-'

export const setLocalStorage = (key: string, value: any): void => {
  value && localStorage.setItem(`${keyBefore}${key}`, typeof value === 'string' ? value : JSON.stringify(value))
}

export const getLocalStorage = <T>(key: string, isParse = false): T => {
  const cache = localStorage.getItem(`${keyBefore}${key}`) ?? ''
  return isParse ? JSON.parse(cache) : cache
}

export const removeLocalStorage = (key: string): void => {
  localStorage.removeItem(`${keyBefore}${key}`)
}

export const setSessionStorage = (key: string, value: any): void => {
  value && sessionStorage.setItem(`${keyBefore}${key}`, typeof value === 'string' ? value : JSON.stringify(value))
}

export const getSessionStorage = <T>(key: string, isParse = false): T => {
  const cache = sessionStorage.getItem(`${keyBefore}${key}`) ?? ''
  return isParse ? JSON.parse(cache) : cache
}

export const getRiskColor = (risk: Risk) => {
  switch (risk) {
    case 'low':
      return 'text-cornflower-blue'
    case 'medium':
      return 'text-vegas-gold'
    case 'high':
      return 'text-indian-red'
    default:
      return 'text-apple'
  }
}

export const getRiskTagColor = (risk: Risk) => {
  switch (risk) {
    case 'low':
      return '#6592EC'
    case 'medium':
      return '#CDBD53'
    case 'high':
      return '#DC6161'
    default:
      return '#6592EC'
  }
}

export const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email)
